// 人工标准拼音
export const PolyphonicMap: { [key: string]: { pinyinDefault: string[]; pinyinNumber: string[] } } = {
  干: {
    pinyinDefault: ['gān'],
    pinyinNumber: ['gan1'],
  },
};
